import { FormattedMessage } from "react-intl";
import {
  AiOutlineFileSearch,
  AiOutlineAppstoreAdd,
  AiOutlineRotateLeft,
  AiOutlineApartment,
  AiFillAppstore,
} from "react-icons/ai";
import {
  MdScreenSearchDesktop,
  MdDocumentScanner,
  MdGroup,
  Md6FtApart,
  MdOutlineTouchApp,
  MdNetworkCell,
  MdAmpStories,
} from "react-icons/md";
import {
  BsBellFill,
  BsBookmarkPlusFill,
  BsFlagFill,
  BsBagCheckFill,
  BsLaptop,
  BsCalendarEventFill,
  BsFilePost,
  BsCameraVideoFill,
  BsNewspaper,
} from "react-icons/bs";
import {
  FaShoppingBag,
  FaFileContract,
  FaBlogger,
  FaQuestion,
} from "react-icons/fa";
import { RiCompassDiscoverFill, RiBarChartFill } from "react-icons/ri";
import { GiSkills } from "react-icons/gi";
import { BiPlanet, BiHappyAlt } from "react-icons/bi";
import { HiOfficeBuilding } from "react-icons/hi";
import { ImMobile } from "react-icons/im";

export const caseData = [
  {
    title: (
      <FormattedMessage id="mobile-nav-case1-title" defaultMessage="EthTrade" />
    ),
    text: (
      <FormattedMessage
        id="Helping"
        defaultMessage="Helping a fintech leader redesign web and mobile app. "
      />
    ),
  },

  {
    title: (
      <FormattedMessage
        id="mobile-nav-case2-title"
        defaultMessage="LearnSeek"
      />
    ),
    text: (
      <FormattedMessage
        id="Evolving"
        defaultMessage="Evolving the UX of an e-learning platform to drive enrollment."
      />
    ),
  },

  {
    title: (
      <FormattedMessage
        id="mobile-nav-case3-title"
        defaultMessage="B-Shipping"
      />
    ),
    text: (
      <FormattedMessage
        id="Rebranding"
        defaultMessage="Rebranding of a shipping logistics provider."
      />
    ),
  },
];

export const searchData = [
  {
    link: <FormattedMessage id="mobile-nav1-link1" defaultMessage="Jobs" />,
    to: "/",
    icon: <AiOutlineFileSearch />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link2"
        defaultMessage="Recent Researches"
      />
    ),
    to: "/",
    icon: <MdScreenSearchDesktop />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav1-link3" defaultMessage="Job Alerts" />
    ),
    to: "/",
    icon: <BsBellFill />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav1-link4" defaultMessage="Saved Jobs" />
    ),
    to: "/",
    icon: <BsBookmarkPlusFill />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link5"
        defaultMessage="Job Applications"
      />
    ),
    to: "/",
    icon: <MdDocumentScanner />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link6"
        defaultMessage="Suggested jobs"
      />
    ),
    to: "/",
    icon: <FaShoppingBag />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav1-link7" defaultMessage="Discover Jobs" />
    ),
    to: "/",
    icon: <RiCompassDiscoverFill />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link8"
        defaultMessage="Jobs by Skills"
      />
    ),
    to: "/",
    icon: <GiSkills />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav1-link9" defaultMessage="Latest Jobs" />
    ),
    to: "/",
    icon: <AiOutlineAppstoreAdd />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link10"
        defaultMessage="Featured Jobs"
      />
    ),
    to: "/",
    icon: <RiBarChartFill />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link11"
        defaultMessage="Jobs by Language"
      />
    ),
    to: "/",
    icon: <BsFlagFill />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav1-link12"
        defaultMessage="Jobs by Country"
      />
    ),
    to: "/",
    icon: <BiPlanet />,
  },
];

export const aboutData = [
  {
    link: <FormattedMessage id="mobile-nav6-link1" defaultMessage="Company" />,
    to: "/",
    icon: <BsBagCheckFill />,
  },

  {
    link: <FormattedMessage id="mobile-nav6-link2" defaultMessage="Team" />,
    to: "/",
    icon: <MdGroup />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav6-link3"
        defaultMessage="Mission&Values"
      />
    ),
    to: "/",
    icon: <AiOutlineRotateLeft />,
  },

  {
    link: <FormattedMessage id="mobile-nav6-link4" defaultMessage="Partners" />,
    to: "/",
    icon: <Md6FtApart />,
  },

  {
    link: <FormattedMessage id="mobile-nav6-link5" defaultMessage="Careers" />,
    to: "/",
    icon: <FaFileContract />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav6-link6" defaultMessage="Social media" />
    ),
    to: "/",
    icon: <BsLaptop />,
  },

  {
    link: <FormattedMessage id="mobile-nav6-link7" defaultMessage="Events" />,
    to: "/",
    icon: <BsCalendarEventFill />,
  },

  {
    link: (
      <FormattedMessage id="WhatWeDo" defaultMessage="What we do" />
    ),
    to: "/",
    icon: <AiOutlineApartment />,
  },

  {
    link: (
      <FormattedMessage
        id="mobile-nav6-link9"
        defaultMessage="Happy customers"
      />
    ),
    to: "/",
    icon: <BiHappyAlt />,
  },

  {
    link: <FormattedMessage id="mobile-nav6-link10" defaultMessage="Why us?" />,
    to: "/",
    icon: <MdOutlineTouchApp />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav6-link11" defaultMessage="Categories" />
    ),
    to: "/",
    icon: <AiFillAppstore />,
  },

  {
    link: (
      <FormattedMessage id="mobile-nav6-link12" defaultMessage="Our offices" />
    ),
    to: "/",
    icon: <HiOfficeBuilding />,
  },
];

export const resourcesData = [
  {
    link: (
      <FormattedMessage id="mobile-nav5-link1" defaultMessage="Publications" />
    ),
    to: "/",
    icon: <BsFilePost />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link2" defaultMessage="Webinars" />,
    to: "/",
    icon: <BsCameraVideoFill />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link3" defaultMessage="Blog" />,
    to: "/",
    icon: <FaBlogger />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link4" defaultMessage="News" />,
    to: "/",
    icon: <BsNewspaper />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link5" defaultMessage="FAQs" />,
    to: "/",
    icon: <FaQuestion />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link6" defaultMessage="Network" />,
    to: "/",
    icon: <MdNetworkCell />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link7" defaultMessage="Our Apps" />,
    to: "/",
    icon: <ImMobile />,
  },

  {
    link: <FormattedMessage id="mobile-nav5-link8" defaultMessage="Stories" />,
    to: "/",
    icon: <MdAmpStories />,
  },
];
